module.exports = __webpack_public_path__ + "media/images/icons/country_flags/vu-6d2ce93c9b9c7da6640c6880a485807f.svg";